class PhotochromicLensGuide {
  constructor(root) {
    this.root = root;
    this.openButtons = Array.from(root.querySelectorAll('[data-lens-guide-open]'));
    this.dialogs = Array.from(root.querySelectorAll('[data-lens-guide-dialog]'));
    this.sequences = Array.from(root.querySelectorAll('[data-photochromic-sequence]'));
    this.activeOpenButton = null;

    this.openButtons.forEach((button) => {
      button.addEventListener('click', () => this.open(button));
    });

    this.dialogs.forEach((dialog) => {
      const closeButton = dialog.querySelector('[data-lens-guide-close]');
      closeButton?.addEventListener('click', () => this.close(dialog));

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) this.close(dialog);
      });

      dialog.addEventListener('close', () => {
        this.pauseVideos(dialog);
        document.documentElement.classList.remove('photochromic-guide-is-open');
        this.activeOpenButton?.focus({ preventScroll: true });
        this.activeOpenButton = null;
      });
    });

    this.sequences.forEach((sequence) => this.setupSequence(sequence));
  }

  setupSequence(sequence) {
    const frameElement = sequence.querySelector('[data-photochromic-sequence-frame]');
    const range = sequence.querySelector('[data-photochromic-range]');
    if (!frameElement || !range) return;

    const frameCount = Number(frameElement.dataset.sequenceFrames) || 1;
    const columns = Number(frameElement.dataset.sequenceColumns) || 1;
    const rows = Number(frameElement.dataset.sequenceRows) || 1;

    const showFrameForRangeValue = () => {
      const progress = Number(range.value) / Number(range.max);
      const frameIndex = Math.min(Math.round(progress * (frameCount - 1)), frameCount - 1);
      const column = frameIndex % columns;
      const row = Math.floor(frameIndex / columns);
      const positionX = columns > 1 ? (column / (columns - 1)) * 100 : 0;
      const positionY = rows > 1 ? (row / (rows - 1)) * 100 : 0;

      frameElement.style.backgroundPosition = `${positionX}% ${positionY}%`;
      this.updateRangeProgress(range);
    };

    range.addEventListener('input', showFrameForRangeValue);
    range.addEventListener('change', showFrameForRangeValue);
    showFrameForRangeValue();
  }

  updateRangeProgress(range) {
    const min = Number(range.min) || 0;
    const max = Number(range.max) || 100;
    const value = Number(range.value) || 0;
    const progress = ((value - min) / (max - min)) * 100;
    range.style.setProperty('--range-progress', `${progress}%`);
  }

  open(button) {
    const dialogId = button.dataset.lensGuideOpen;
    const dialog = this.dialogs.find((item) => item.id === dialogId);
    if (!dialog) return;

    this.activeOpenButton = button;
    document.documentElement.classList.add('photochromic-guide-is-open');
    dialog.showModal();
  }

  close(dialog) {
    if (dialog?.open) dialog.close();
  }

  pauseVideos(dialog) {
    dialog.querySelectorAll('[data-lens-guide-video]').forEach((video) => {
      video.pause();
    });
  }
}

const initPhotochromicLensGuides = (container = document) => {
  container.querySelectorAll('[data-photochromic-guide]').forEach((root) => {
    if (root.dataset.photochromicInitialized === 'true') return;
    root.dataset.photochromicInitialized = 'true';
    new PhotochromicLensGuide(root);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initPhotochromicLensGuides());
} else {
  initPhotochromicLensGuides();
}

document.addEventListener('shopify:section:load', (event) => initPhotochromicLensGuides(event.target));
